import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { LayersNestedList } from 'components/LayersTab/LayersBlock/LayersNestedList';
import { Box } from '@mui/material';

export const LayersBlock: React.FC = (): JSX.Element => {
  const { allLayers } = useAppSelector((state) => state.layers);

  return (
    <Box sx={{ maxHeight: 'calc(100vh - 270px)', overflow: 'auto' }}>
      <LayersNestedList list={allLayers} />
    </Box>
  );
};
